<template>
  <v-content class="in invites page">
    <can I="list" a="Invite">
      <v-container>
        <v-toolbar   flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[{ exact: true, text: 'Admin', to: '/dashboard' },
                     { exact: true, text: 'Invites', to: '/invites' }]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-tooltip left>
            <v-btn small flat fab slot="activator" @click="filter">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
        </v-toolbar>

        <!-- Heading and Search -->
        <v-card dark toolbar>
          <v-toolbar flat class="transparent">
            <v-card-title>
              <div class="headline">Invites</div>
            </v-card-title>

            <v-spacer />

            <v-text-field
              prepend-icon="mdi-magnify"
              type="search"
              v-model="search"
              placeholder="Search"
              @keyup.enter="filter"
            />

            <v-btn color="secondary" @click="filter">Filter</v-btn>

            <v-btn v-if="filtersApplied" @click="showFilters = !showFilters" small flat fab color="accent" >
              <v-icon>mdi-filter-variant</v-icon>
            </v-btn>
            <v-btn v-else @click="showFilters = !showFilters" small flat fab>
              <v-icon>mdi-filter-variant</v-icon>
            </v-btn>
          </v-toolbar>

          <!-- Filters -->
          <transition name="slide-y-transition">
            <v-card-text v-show="showFilters">
              <OpportunitySelect clearable v-model="filters.opportunity" />
            </v-card-text>
          </transition>

          <!-- Table -->
          <v-data-table
            :headers="headers"
            :items="active"
            :total-items="total" must-sort
            :pagination.sync="pagination"
            @update:pagination="filter"
            :loading="loading"
            class="elevation-2"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td><router-link :to="`/opportunities/${props.item.opportunity.id}`">
                {{ props.item.opportunity.name }}
              </router-link></td>
              <td><router-link :to="`/profiles/${props.item.profile.id}`">
                {{ props.item.profile.fullName }}
              </router-link></td>
              <td>
                <v-tooltip right>
                  <span slot="activator">{{ new Date(props.item.createdAt) | inWords({ addSuffix: true }) }}</span>
                  <span>{{ new Date(props.item.createdAt) | date('MM/dd/yyyy') }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip right>
                  <span slot="activator">
                    {{ twoWeeksFrom(props.item.createdAt) | inWords({ addSuffix: true }) }}
                  </span>
                  <span>
                    {{ twoWeeksFrom(props.item.createdAt) | date("MM/dd/yyyy") }}
                  </span>
                </v-tooltip>
              </td>
              <td>
                <v-icon color="success" v-if="props.item.active">
                  mdi-check
                </v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import OpportunitySelect from '@/components/selects/OpportunitySelect'

// Helpers
import _ from 'lodash'
import axios from 'axios'
import { mapState } from 'vuex'

// Vue Component
export default {
  components: { OpportunitySelect },
  created() {
    this.$store.commit('admin/invites/seed', axios.CancelToken.source())
  },
  beforeDestroy() {
    this.$store.dispatch('admin/invites/abandon')
  },
  data() {
    return {
      // Search and filters
      search: this.$route.query.search || '',
      showFilters: this.$route.query.opportunity,
      filters: {
        opportunity: this.$route.query.opportunity ? parseInt(this.$route.query.opportunity) : null
      },
      // Table Configuration
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Opportunity', value: 'opportunity.name', sortable: false },
        { text: 'Profile', value: 'profile.fullName', sortable: false },
        { text: 'Invited at', value: 'createdAt' },
        { text: 'Expires', value: 'createdAt' },
        { text: 'Active', value: 'active', sortable: false }
      ],
      pagination: { sortBy: 'createdAt', descending: true, rowsPerPage: 25 }
    }
  },
  computed: {
    ...mapState('admin/invites', ['active', 'loading', 'total', 'page', 'rowsPerPage']),
    ...mapState('admin/opportunities', { opportunities: 'all', opportunitiesLoading: 'loading' }),
    filtersApplied() {
      return this.filters.opportunity !== null
    },
  },
  methods: {
    filter(payloadOrEvent) {
      // Update URL
      const filters = Object.assign(this.filters, { search: this.search })
      this.$router.replace(Object.assign({}, this.$route, { query: _.pickBy(filters) }))
      // Fetch new data that matches filters and search
      this.$store.dispatch(
        'admin/invites/search',
        Object.assign(
          { search: this.search },
          { filters: this.filters },
          typeof payloadOrEvent == 'KeyboardEvent' ? {} : payloadOrEvent
        )
      )
    },
    twoWeeksFrom(date) {
      let from = typeof date.getDate === 'function' ? date : new Date(date)
      return from.setDate(from.getDate() + 14)
    },
  }
}
</script>
